export const roleOptions = [
  {
    value: 'all',
    label: 'Super admin',
    description: ['จัดการ/แก้ไขข้อมูลหน้า-หลังบ้านได้', 'สามารถมองเห็นข้อมูลทั้งหมดในระบบ']
  },
  {
    value: 'supervisor',
    label: 'Supervisor',
    description: ['เข้าถึงระบบ Ticket และหน้ารวมแชท', 'เห็นแชทของทุกคนในกลุ่ม']
  },
  {
    value: 'agent',
    label: 'Agent',
    description: ['เข้าถึงระบบ Ticket และหน้ารวมแชท', 'เห็นเฉพาะแชทของตัวเองเท่านั้น']
  }
]



// WEBPACK FOOTER //
// ./src/constants/ticket3/userConstant.js